<script setup lang="ts">
import { TSDialogConfirm, useLoadingStore, useToast } from 'tsv2-library';

import BorrowingServices from '@/services/borrowing.service';

import useTableStore from '@/store/table.store';

import {
  BorrowingBorrowedByAsset,
  BorrowingTransactionRequest,
} from '@/types/borrowing.type';

const toast = useToast();
const { incrementTableKey } = useTableStore();
const { setLoading } = useLoadingStore();

const visible = defineModel<boolean>('visible', { required: true });

const props = defineProps<{
  selectedData: BorrowingTransactionRequest[] | BorrowingBorrowedByAsset[];
}>();

/**
 * Handle the cancelation to extension request.
 */
const handleCancelExtension = async (): Promise<void> => {
  try {
    setLoading(true);

    await BorrowingServices.putCancelExtendBorrowingRequest(
      props.selectedData.map((datum) => datum._id),
    );

    toast.add({
      message: 'Success, extension request has been canceled.',
      severity: 'success',
    });

    incrementTableKey();
  } catch (error) {
    toast.add({
      error,
      message: 'Error, failed to cancel extension request.',
      severity: 'error',
    });
  } finally {
    setLoading(false);
  }
};
</script>
<template>
  <TSDialogConfirm
    v-model:visible="visible"
    :lists="selectedData.map((datum) => datum.name.nameWithSequence)"
    @confirm="handleCancelExtension"
    body="Are you sure want to continue?"
    confirm-label="Continue"
    data-ts-name="cancel-extension-request"
    header="Cancel Extension Request"
    severity="danger"
  />
</template>
